import { Box, CircularProgress, Container, FormControl, Button, FormControlLabel, Grid, InputAdornment, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Stack, TextField, Typography, IconButton, FormGroup, Checkbox, Backdrop } from '@mui/material'
import React, { useContext, useEffect, useReducer, useRef, useState } from 'react'
import { debounce } from 'lodash';
import dayjs from 'dayjs';
import CropOriginalIcon from '@mui/icons-material/CropOriginal';
import CampaignIcon from '@mui/icons-material/Campaign';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useSettingsContext } from '../../../components/settings';
import { VendorContext } from '../../../contexts/VendorContext';
import searchIcon from '../../../assets/icons/searchicon.svg';
import postUploadImage from '../../../services/campian/uploadImage';
import { useAuthContext } from '../../../auth/useAuthContext';
import { notify } from '../../../components/notify';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import getCampianCategory from '../../../services/campian/getCategory';
import getCampianLanguages from '../../../services/campian/getLanguages';
import getMetaAccount from 'src/services/campian/getMetaAccount';
import { useCampaignTemplateContext } from 'src/contexts/CampaignTemplateContext';
import CustomInput from 'src/components/customerinput/CustomerInput';
import CallIcon from '@mui/icons-material/Call';
import LaunchIcon from '@mui/icons-material/Launch';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useLocation, useNavigate } from 'react-router';
import createCampiantemplate from 'src/services/campian/createTemplate';
import updateTemplate from 'src/services/campian/updateTemplate';
import { LoadingButton } from '@mui/lab';
import getCampianAssignVendorGroups from 'src/services/campian/getAssignGroupDataVendor';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { EmojiEmotions } from "@mui/icons-material";
import EmojiPicker from 'emoji-picker-react';
import useModalControl from 'src/components/cards/useModalControl';
import updateTemplateStatus from 'src/services/campian/updateTemplateStatus';
import getCampianGroups from 'src/services/campian/getGroupData';
import ReplyIcon from '@mui/icons-material/Reply';
import getDiscountEventsDetailsData from 'src/services/discount/getDiscountPopDeatails';
import getEventsStrikePackages from 'src/services/eventLabel/geteventPackages';
import { handleKeyPress, truncateText } from 'src/functions';
import getZeroPackages from 'src/services/getZeroPackageByEventId';
import createQrCode from 'src/services/createQrCode';
import getLiveAndUpcomingEvents from 'src/services/events/getLiveAndUpcomingEvents';
const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'vendorType':
            return {
                ...state,
                vendorType: payload

            }
        case 'meta_acc_id':
            return {
                ...state,
                meta_acc_id: payload

            }
        case 'vendorId':
            return {
                ...state,
                vendorId: payload

            }
        case 'variable':
            return {
                ...state,
                variable: payload

            }
        case 'name':
            return {
                ...state,
                name: payload?.trimStart()

            }
        case 'language':
            return {
                ...state,
                language: payload

            }
        case 'template':
            return {
                ...state,
                template: payload

            }
        case 'phone_number':
            return {
                ...state,
                phone_number: payload

            }
        case 'header.format':
            return {
                ...state,
                header: { ...state?.header, format: payload?.trimStart() }
            }
        case 'body.example.header_text':
            return {
                ...state,
                body: { ...state?.body, example: { ...state?.body?.example, header_text: payload?.trimStart() } }
            }
        case 'header.example.header_text':
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, header_text: payload?.trimStart() } }
            }
        case 'header.example.header_handle':
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, header_handle: payload } }
            }
        case 'header.example?.type':
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, type: payload, header_text: "", dynamic_Key: "" } }
            }
        case 'header.example?.dynamic_Key':
            const dynamicValue = state?.template_feilds.find((it) => it?._id == payload)
            let name = ""
            if (dynamicValue.handle == "customer-name") {
                name = "guest"
            } else {
                name = "vendor"
            }
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, dynamic_Key: payload?.trimStart(), header_text: name } }
            }
        case 'header.example?.display_name':
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, display_name: payload?.trimStart() } }
            }
        case 'body.example?.type':
            return {
                ...state,
                body: { ...state?.body, example: { ...state?.body?.example, type: payload } }
            }
        case 'header.text': {
            return {
                ...state,
                header: { ...state?.header, text: payload?.trimStart() },
                headerError: validateInput(payload?.trimStart(), state)
            }
        }
        case 'body.text': {
            return {
                ...state,
                body: { ...state?.body, text: payload?.trimStart() },
            }
        }
        case 'bodyplaceholder': {
            return {
                ...state,
                bodyplaceholder: payload,
            }
        }
        case 'bodyError': {
            return {
                ...state,
                bodyError: payload,
            }
        }
        case 'footerText': {
            return {
                ...state,
                footerText: payload?.trimStart(),
            }
        }
        case 'assign_number': {
            return {
                ...state,
                assign_number: payload,
            }
        }
        case 'selectedImage': {
            return {
                ...state,
                selectedImage: payload,
            }
        }
        case 'selectedVideo': {
            return {
                ...state,
                selectedVideo: payload,
            }
        }
        case 'template_feilds': {
            return {
                ...state,
                template_feilds: payload,
            }
        }
        case 'visiteButton': {

            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            status: payload?.checked
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.text': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            text: payload?.text?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.quick.text': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            text: payload?.text?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.display_name': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            display_name: payload?.text?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.type': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    let newObj = {}
                    if (payload.label == "Other") {
                        newObj = {
                            ButtonText: "Event Link",
                            text: "Event Link",
                            example: {
                                header_text: "event",  // if we added variables 
                            },
                            display_name: "Select Event"
                        }
                    }

                    if (index == payload?.index) {
                        return {
                            ...it,
                            type: payload?.type,
                            url: payload?.type == 'STATIC' ? "https://ticketsque.com/events/" : "https://ticketsque.com/{{1}}",
                            ...newObj

                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.dynamic_Key': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            dynamic_Key: payload?.dynamic_Key?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.url': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            url: payload?.url?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.code': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            code: payload?.code?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.phone_number': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            phone_number: payload?.phone_number?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.example.header_text': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            example: { header_text: payload?.header_text?.trimStart() }
                        }
                    }
                    return it
                }),
            }
        }
        case 'bodyplaceholder.value': {

            return {
                ...state,
                bodyplaceholder: state.bodyplaceholder?.map(item =>
                    item.key === payload.key ? { ...item, value: payload.value?.trimStart() } : item
                )
            }
        }
        case 'bodyplaceholder.type': {
            return {
                ...state,
                bodyplaceholder: state.bodyplaceholder?.map(item =>
                    item.key === payload.key ? {
                        ...item,
                        type: payload.type,
                        value: "",
                        dynamic_Key: payload.type == 'STATIC' ? "" : item?.dynamic_Key,

                    } : item
                )
            }
        }
        case 'bodyplaceholder.dynamic_Key': {
            const dynamicValue = state?.template_feilds.find((it) => it?._id == payload.dynamic_Key)
            let name = ""
            if (dynamicValue.handle == "customer-name") {
                name = "guest"
            } else {
                name = "vendor"
            }

            return {
                ...state,
                bodyplaceholder: state.bodyplaceholder?.map(item =>
                    item.key === payload.key ? { ...item, dynamic_Key: payload.dynamic_Key?.trimStart(), value: name } : item
                )
            }
        }
        case 'bodyplaceholder.display_name': {
            return {
                ...state,
                bodyplaceholder: state.bodyplaceholder?.map(item =>
                    item.key === payload.key ? { ...item, display_name: payload.display_name?.trimStart() } : item
                )
            }
        }
        case 'header.text.variable':
            return {
                ...state,
                header: { ...state?.header, text: state?.header?.text ? `${state?.header?.text} {{1}}` : '{{1}}' }
            }
        case 'template_status':
            return {
                ...state,
                template_status: payload
            }
        case 'body.text.variable': {
            if (state.variable === 'POSITIONAL') {
                // Handle positional variables (existing logic)
                const variablePattern = /\{\{(\d+)\}\}/g;
                let matches = [...state?.body?.text?.matchAll(variablePattern)].map((m) => parseInt(m[1]));
                let nextNumber = matches.length > 0 ? Math.max(...matches) + 1 : 1;
                let newText = state?.body?.text + ` {{${nextNumber}}}`;

                return {
                    ...state,
                    body: { ...state?.body, text: newText },
                    bodyError: validateMessage(newText, state)
                }
            } else {
                // Handle NAMED and UNIQUE_NAME variables
                const variableTemplates = {
                    NAMED: ['user', "vendor", "customer"],
                };

                const template = variableTemplates[state.variable];
                const variablePattern = /\{\{([a-zA-Z_][a-zA-Z0-9_]*)\}\}/g;
                const existingVariables = [...state?.body?.text?.matchAll(variablePattern)].map(m => m[1]);

                // Find the next variable name
                let nextVariable;
                if (existingVariables.length < template.length) {
                    nextVariable = template[existingVariables.length];
                } else {
                    // If we've used all templates, start adding numbers
                    const baseName = template[0];
                    const count = existingVariables.filter(v => v.startsWith(baseName)).length;
                    nextVariable = `${baseName}_${count + 1}`;
                }

                let newText = state?.body?.text + ` {{${nextVariable}}}`;

                return {
                    ...state,
                    body: { ...state?.body, text: newText },
                    bodyError: validateMessage(newText, state)
                }
            }
        }
        case 'visiteButton.ButtonText': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            ButtonText: payload?.text?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.staticValue': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            staticValue: payload?.text?.trimStart(),
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.event_id': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            event_id: payload?.event_id?.trimStart(),
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.package': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            package: payload?.package?.trimStart(),
                        }
                    }
                    return it
                }),
            }
        }
        case 'edit': {
            const { category, language, meta_acc_id, name, components, variables, meta_template_id, vendor, meta_phone_number_id, active, parameter_format } = payload

            const variableBody = JSON.parse(variables)?.body
            const variableHeader = JSON.parse(variables)?.header
            const variableButtons = JSON.parse(variables)?.button
            let header = components.find((it) => it?.type == 'HEADER')
            let body = components.find((it) => it?.type == 'BODY')
            let button = components.find((it) => it?.type == 'BUTTONS')
            if (button?.buttons?.length) {
                button = button?.buttons.map((it) => {
                    const check = variableButtons.find((ite) => ite?.value == it?.text)
                    if (it?.type == 'URL' && check?.type == 'DYNAMIC') {
                        return {
                            label: "Other",
                            ButtonText: check.ButtonText,
                            staticValue: check.staticValue,
                            status: true,
                            text: it?.text,
                            type: check?.type,
                            dynamic_Key: "",
                            display_name: check.feild_name,
                            url: it?.url,
                            example: {
                                header_text: it?.example[0]
                            },
                            buttonType: "URL",
                            event_id: check.event_id || ""
                        }
                    }
                    if (it?.type == 'URL') {
                        return {
                            label: "Other",
                            status: true,
                            text: it?.text,
                            ButtonText: check.ButtonText,
                            staticValue: check.staticValue,
                            type: "STATIC",
                            dynamic_Key: "",
                            display_name: "",
                            url: "https://ticketsque.com/events/",
                            example: {
                                header_text: ""
                            },
                            buttonType: "URL",
                            event_id: check.event_id || ""
                        }
                    }
                    if (it.type == "PHONE_NUMBER") {
                        return {
                            label: "RSVP",
                            status: true,
                            text: it.text,
                            phone_number: it.phone_number,
                            buttonType: "PHONE_NUMBER",
                            type: "STATIC",
                        }
                    }

                }).filter(Boolean)
                if (!button.some((it) => it.label == "Other")) {
                    button = [
                        ...button,
                        {
                            label: "Other", status: false,
                            ButtonText: "Event Link",
                            text: "Event Link",
                            type: "STATIC",
                            staticValue: "",
                            dynamic_Key: "",
                            url: "https://ticketsque.com/events/",
                            example: {
                                header_text: "",  // if we added variables 
                            },
                            buttonType: "URL",
                            display_name: "",
                            event_id: ""
                        }
                    ]
                }
                if (!button.some((it) => it.label == "RSVP")) {
                    button = [
                        ...button,
                        { label: "RSVP", status: false, text: "RSVP", phone_number: "", buttonType: "PHONE_NUMBER", type: "STATIC", },
                    ]
                }

                if (!button?.length) {
                    button = [
                        ...button,
                        {
                            label: "Other", status: false,
                            ButtonText: "Event Link",
                            text: "Event Link",
                            type: "STATIC",
                            staticValue: "",
                            dynamic_Key: "",
                            url: "https://ticketsque.com/events/",
                            example: {
                                header_text: "",  // if we added variables 
                            },
                            buttonType: "URL",
                            display_name: "",
                            event_id: ""
                        }
                    ]
                }

                const check = variableButtons.find((it) => it?.label == "Chat with us")

                if (check) {
                    button = [
                        ...button,
                        { label: "Chat with us", status: check.isStatus, text: "Chat with us", code: "", buttonType: "QUICK_REPLY" }
                    ]
                } else {
                    button = [
                        ...button,
                        { label: "Chat with us", status: false, text: "Chat with us", code: "", buttonType: "QUICK_REPLY" }
                    ]
                }
                const check2 = variableButtons.find((it) => it?.label == "Join As Guest")
                if (check2) {
                    button = [
                        ...button,
                        { label: "Join As Guest", status: check2.isStatus || false, text: check2.value, code: "", buttonType: "GUEST", staticValue: check2.staticValue, event_id: check2.event_id || "", package: check2.package || "", }
                    ]
                } else {
                    button = [
                        ...button,
                        { label: "Join As Guest", status: false, text: "Join As Guest", code: "", buttonType: "GUEST", staticValue: "", package: "", },
                    ]
                }
                const check3 = variableButtons.find((it) => it?.label == "Donate Now")
                if (check3) {
                    button = [
                        ...button,
                        { label: "Donate Now", status: check3.isStatus || false, text: check3.value || "Donate Now", code: "", buttonType: "QUICK_REPLY" }
                    ]
                } else {
                    button = [
                        ...button,
                        { label: "Donate Now", status: false, text: "Donate Now", code: "", buttonType: "QUICK_REPLY" }
                    ]
                }
            } else {
                button = [{
                    label: "Other", status: false,
                    ButtonText: "Event Link",
                    text: "Event Link",
                    type: "STATIC",
                    staticValue: "",
                    dynamic_Key: "",
                    url: "https://ticketsque.com/events/",
                    example: {
                        header_text: "",  // if we added variables 
                    },
                    buttonType: "URL",
                    display_name: "",
                    event_id: ""
                },
                { label: "RSVP", status: false, text: "RSVP", phone_number: "", buttonType: "PHONE_NUMBER", type: "STATIC", },
                { label: "Chat with us", status: true, text: "Chat with us", code: "", buttonType: "QUICK_REPLY" },
                { label: "Donate Now", status: false, text: "Donate Now", code: "", buttonType: "QUICK_REPLY" },
                { label: "Join As Guest", status: false, text: "Join As Guest", code: "", buttonType: "GUEST", staticValue: "", package: "", },
                ]
            }
            const footer = components.find((it) => it?.type == 'FOOTER')
            if (!header) {
                header = {
                    meta_type: "HEADER",
                    format: "NONE",
                    text: "",
                    example: {
                        type: "STATIC",
                        header_text: "",
                        header_handle: "",
                        dynamic_Key: "",
                        display_name: ""
                    }
                }
            } else {

                if (header?.format == 'IMAGE') {
                    header = {
                        meta_type: "HEADER",
                        format: header?.format,
                        example: {
                            type: "STATIC",
                            header_text: "",
                            header_handle: header?.example?.header_handle[0],
                            dynamic_Key: "",
                            display_name: ""
                        }
                    }
                }
                if (header?.format == 'VIDEO') {
                    header = {
                        meta_type: "HEADER",
                        format: header?.format,
                        example: {
                            type: "STATIC",
                            header_text: "",
                            header_handle: header?.example?.header_handle[0],
                            dynamic_Key: "",
                            display_name: ""
                        }
                    }
                }

                if (header?.format == 'TEXT') {
                    if (parameter_format != "NAMED") {
                        header = {
                            meta_type: "HEADER",
                            format: header?.format,
                            text: header.text,
                            example: {
                                // type: header?.example?.header_text.length > 0 ? "DYNAMIC" : "STATIC",
                                type: variableHeader[0]?.type || "STATIC",
                                header_text: header?.example?.header_text[0] || "",
                                header_handle: "",
                                dynamic_Key: variableHeader[0]?.feild_name || "",
                                display_name: variableHeader[0]?.value || ""
                            }
                        }
                    } else {
                        header = {
                            meta_type: "HEADER",
                            format: header?.format,
                            text: header.text,
                            example: {
                                // type: header?.example?.header_text.length > 0 ? "DYNAMIC" : "STATIC",
                                type: variableHeader[0]?.type || "STATIC",
                                header_text: header?.example?.header_text_named_params[0]?.example || "",
                                header_handle: "",
                                dynamic_Key: variableHeader[0]?.feild_name || "",
                                display_name: variableHeader[0]?.value || ""
                            }
                        }
                    }
                }

            }
            if (body) {
                body = {
                    meta_type: "BODY",
                    text: body?.text,
                }
            }

            let matches = variableBody.map((it) => {
                const key = state?.template_feilds?.find((ite) => ite?._id == it?.feild_name)?._id
                return { key: `{{${it?.key_value}}}`, value: it?.fallback_value, type: it?.type, dynamic_Key: key || null, display_name: it?.value }
            })

            let vendorType = "all";
            let vendorId = "";
            if (vendor) {
                vendorType = "individual"
            }
            if (vendor) {
                vendorId = vendor?._id
            }

            return {
                ...state,
                template: category?._id,
                language: language?._id,
                meta_acc_id: meta_acc_id,
                name: name,
                selectedImage: header?.format == 'IMAGE' ? 'https://ticketsque-public.s3.ap-south-1.amazonaws.com/logo12092024.png' : "",
                selectedVideo: header?.format == 'VIDEO' ? 'https://tq-events-staging-public.s3.ap-south-1.amazonaws.com/invoices/file_example_MP4_640_3MG+1.mp4' : "",
                header,
                body,
                bodyplaceholder: matches,
                footerText: footer?.text,
                visiteButton: button,
                template_id: meta_template_id,
                vendorId,
                vendorType,
                phone_number: meta_phone_number_id,
                template_status: active,
                variable: parameter_format
            }
        }

        default:
            return state
    }

}

const validateMessage = (message, state) => {
    // Check max length
    if (message.length > 1024) {
        return "Message exceeds maximum length of 1024 characters.";
    }

    // Check for different variable types
    const positionalPattern = /\{\{(\d+)\}\}/g;
    const namedPattern = /\{\{([a-zA-Z_][a-zA-Z0-9_]*)\}\}/g;

    const positionalMatches = [...message.matchAll(positionalPattern)].map((m) => parseInt(m[1]));
    const namedMatches = [...message.matchAll(namedPattern)].map((m) => m[1]);

    // Validate based on selected variable type
    if (state.variable === 'POSITIONAL') {
        if (namedMatches.length > 0) {
            return "Named variables are not allowed when using positional variable type. Please use {{1}}, {{2}}, etc.";
        }

        if (positionalMatches.length > 0) {
            let sortedMatches = [...positionalMatches].sort((a, b) => a - b);
            for (let i = 0; i < sortedMatches.length; i++) {
                if (sortedMatches[i] !== i + 1) {
                    return "Variable parameters are missing or not sequential.";
                }
            }
        }
    } else {
        if (positionalMatches.length > 0) {
            return "Positional variables are not allowed when using named variable type. Please use {{variable_name}} format.";
        }

        // Validate named variables format
        const invalidNamedMatches = namedMatches.filter(name => !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(name));
        if (invalidNamedMatches.length > 0) {
            return `Invalid variable names: ${invalidNamedMatches.join(', ')}. Variable names must start with a letter or underscore and contain only letters, numbers, and underscores.`;
        }
        // ✅ Check uniqueness of named variables
        const duplicates = namedMatches.filter((name, idx) => namedMatches.indexOf(name) !== idx);
        if (duplicates.length > 0) {
            return `Duplicate variable names found: ${[...new Set(duplicates)].join(', ')}. Please use unique variable names.`;
        }
    }

    const totalWords = message.replace(/{{\d+}}/g, "").replace(/\{\{[a-zA-Z_][a-zA-Z0-9_]*\}\}/g, "").split(/\s+/).filter(Boolean).length;
    const totalVariables = positionalMatches.length + namedMatches.length;

    if (totalVariables > totalWords / 3) {
        return "The body text contains too many variable parameters relative to the message length. Each variable should have at least 3 words associated with it (3:1 ratio minimum)."
    }

    if (/\{\{.*[#\$%].*\}\}/.test(message)) {
        return "Variable parameters contain invalid special characters.";
    }

    // Ensure message template does not end with a variable
    if (message.trim().match(/\{\{\d+\}\}$/) || message.trim().match(/\{\{[a-zA-Z_][a-zA-Z0-9_]*\}\}$/)) {
        return "Message template cannot end with a variable parameter.";
    }

    // Check for potentially abusive or threatening content
    const prohibitedPhrases = [
        "legal action",
        "publicly shame",
        "threaten",
    ];
    if (prohibitedPhrases.some((phrase) => message.toLowerCase().includes(phrase))) {
        return "Message contains potentially abusive or threatening content.";
    }

    return "";
};

const validateInput = (input, state) => {
    if (!input.includes("{{")) return null;

    if (state.variable === 'POSITIONAL') {
        const pattern = /(^|\s)\{\{[1]\}\}($|\s)|(^|\s)\{\{$/;
        if (!pattern.test(input)) {
            return 'This template contains variable parameters with incorrect formatting. Variable parameters must be whole numbers with two sets of curly brackets (for example, {{1}}).'
        }
        const matches = input.match(/\{\{\d+\}\}/g);
        if (matches && new Set(matches).size > 1) {
            return 'Multiple different placeholders are not allowed. Use only one type, such as {{1}}, throughout the text.';
        }
        if (matches && input.includes("{{}}")) {
            return "Invalid use of empty curly brackets. Once a numbered placeholder (e.g., {{1}}) is used, empty brackets {{}} are not allowed.";
        }
    } else {
        const namedPattern = /\{\{([a-zA-Z_][a-zA-Z0-9_]*)\}\}/g;
        const matches = input.match(namedPattern);

        if (matches) {
            const invalidMatches = matches.filter(match => !/^\{\{[a-zA-Z_][a-zA-Z0-9_]*\}\}$/.test(match));
            if (invalidMatches.length > 0) {
                return 'Named variables must follow the pattern {{variable_name}} with only letters, numbers, and underscores.';
            }

            // Check for consistent variable usage
            const variableNames = matches.map(match => match.replace('{{', '').replace('}}', ''));
            if (new Set(variableNames).size > 1 && state.variable === 'UNIQUE_NAME') {
                return 'Unique name variables should use consistent naming. Use the same variable name throughout.';
            }
        }
    }

    return null;
};
const extractPlaceholders = (input, state) => {
    if (state.variable === 'POSITIONAL') {
        const matches = input.match(/\{\{\d+\}\}/g);
        return matches || [];
    } else {
        const matches = input.match(/\{\{[a-zA-Z_][a-zA-Z0-9_]*\}\}/g);
        return matches || [];
    }

};
function getNumberFromString(str) {
    const match = str.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
}

export default function CreateCampianTemplete() {
    const { user, logout } = useAuthContext()
    const location = useLocation()
    let isRead = location.state?.isreadOnly || false
    const navigate = useNavigate()
    const { template_feilds } = useCampaignTemplateContext();
    const { themeStretch } = useSettingsContext();
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false)
    const { vendors, getVendor } = useContext(VendorContext);
    const [selectGroup, setSelectGroup] = useState()
    const [groupNames, setGroupNames] = useState([])
    const [vendorRecords, setVendorRecords] = useState([])
    useEffect(() => {
        if (vendors) {
            setVendorRecords(vendors)
        }
    }, [vendors])
    const [state, dispatch] = useReducer(reducer, {
        vendorType: "all",
        variable: "POSITIONAL",
        meta_acc_id: "",
        name: "",
        phone_number: "",
        language: "",
        template: "",
        header: {
            meta_type: "HEADER",
            format: "NONE",
            text: "",
            example: {
                type: "STATIC",
                header_text: "",  // if we added variables 
                header_handle: "",
                dynamic_Key: "",
                display_name: ""
            }
        },
        body: {
            meta_type: "BODY",
            text: "Hello",
        },
        vendorId: "",
        template_feilds: [],
        footerText: "Send STOP to unsubscribe | Powered by ticketsque.com",
        bodyplaceholder: [],
        headerError: '',
        bodyError: "",
        assign_number: [],
        visiteButton: [
            {
                label: "Other", status: false,
                ButtonText: "Event Link",
                text: "Event Link",
                type: "STATIC",
                staticValue: "",
                dynamic_Key: "",
                url: "https://ticketsque.com/events/", example: {
                    header_text: "",  // if we added variables 
                },
                buttonType: "URL",
                display_name: "",
                event_id: ""
            },
            { label: "RSVP", status: false, text: "RSVP", phone_number: "", buttonType: "PHONE_NUMBER", type: "STATIC", },
            // { label: "Copy offer code", status: false, text: "Copy offer code", code: "", buttonType: "COPY_CODE" },
            { label: "Chat with us", status: false, text: "Chat with us", code: "", buttonType: "QUICK_REPLY" },
            { label: "Donate Now", status: false, text: "Donate Now", code: "", buttonType: "QUICK_REPLY" },
            { label: "Join As Guest", status: false, text: "Join As Guest", code: "", buttonType: "GUEST", staticValue: "", package: "", event_id: "" },
        ],
        template_status: "0"
    })

    const [imagePath, setImagePath] = useState()
    const [videoPath, setVideoPath] = useState()
    const [loadingUpload, setLoadingUpload] = useState(false)
    const handleImageChange = async (event) => {
        try {
            const file = event.target.files[0];
            if (!file) return;
            const allowedTypes = ["image/png", "image/jpeg"];

            if (!allowedTypes.includes(file.type)) {
                notify("Only PNG and JPG images are allowed!");
                return;
            }
            if (file) {
                handleChangeValue('selectedImage', URL.createObjectURL(file)); // Preview ke liye
                setImagePath(file)
            }
            const formData = new FormData()
            formData.append('image', file)
            const url = `/service/campaign_service/v1/campaign/template/image_upload`
            setLoadingUpload(true)
            const data = await postUploadImage(user, formData, url)
            if (data) {
                handleChangeValue('header.example.header_handle', data?.header_handle)
                notify("Image uploaded successfully", "success")
            }
        } catch (err) {
            console.log(err);

        } finally {
            setLoadingUpload(false)
        }

    };
    const handleVideoChange = async (event) => {
        try {
            const file = event.target.files[0];
            const allowedTypes = ["video/mp4"];

            if (!allowedTypes.includes(file.type)) {
                notify("Only MP4 and WEBM video are allowed!");
                return;
            }
            if (file) {
                const videoURL = URL.createObjectURL(file);
                handleChangeValue('selectedVideo', videoURL); // Preview ke liye
                setVideoPath(file);
                const formData = new FormData()
                formData.append('video', file)
                const url = `/service/campaign_service/v1/campaign/template/video_upload`
                setLoadingUpload(true)
                const data = await postUploadImage(user, formData, url)
                if (data) {
                    handleChangeValue('header.example.header_handle', data?.header_handle)
                    notify("Video uploaded successfully", "success")
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoadingUpload(false)
        }
    };
    const handleChangeValue = (type, payload) => {
        dispatch({ type, payload });
    };
    useEffect(() => {
        const fetchVendor = async () => {
            try {
                setLoading(true);
                await getVendor(0, location.state ? false : true);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        if (state?.vendorType === 'individual' || location.state) {
            if (!selectGroup?.vendorsData?.length) {
                fetchVendor();
            }
        }
    }, [state?.vendorType, getVendor]);
    const filterdVendor = vendorRecords?.filter((item) =>
        item?.name?.toLowerCase().includes(search?.toLowerCase())
    );

    const handleSearchDebounce = debounce((searchText) => {
        setSearch(searchText.trimStart());
    }, 100);

    const handleVendorSearch = (e) => {
        handleSearchDebounce(e.target.value);
    };
    const highlightText = (text, query) => {
        if (!query) return text;
        const regex = new RegExp(`(${query})`, 'gi');
        return text.replace(regex, (match) => `<span style="font-weight: bold; font-size: 20px; color:#7635dc;">${match}</span>`);
    };
    const generateOutput = (output, placeholders, value) => {
        if (placeholders && value) {
            placeholders.forEach((key) => {
                const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                output = output.replace(new RegExp(escapedKey, "g"), value || "");
            });
        }
        return output;
    };
    const generateOutput2 = (output, placeholders) => {
        if (placeholders.length) {
            placeholders.forEach((key) => {
                if (key?.value) {
                    const escapedKey = key?.key?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                    output = output.replace(new RegExp(escapedKey, "g"), key?.value || "");
                }
            });
        }
        output = output.replace(/\*(.*?)\*/g, "<b>$1</b>");
        output = output.replace(/\_(.*?)\_/g, "<i>$1</i>");
        return output;
    };

    const handleRemoveImage = () => {
        handleChangeValue('selectedImage', '')
        handleChangeValue('selectedVideo', '')
        setImagePath();
        handleChangeValue('header.example.header_handle', '')
        document.getElementById("upload-image").value = "";

    }
    const handleRemoveVideo = () => {
        handleChangeValue('selectedVideo', '')
        handleChangeValue('selectedImage', '')
        setVideoPath();
        handleChangeValue('header.example.header_handle', '')
        document.getElementById("upload-video").value = "";

    }

    const prevTextRef = useRef("");
    const handleChange = (event) => {
        let value = event.target.value;
        let newText = value;
        const isBackspace = prevTextRef.current.length > value.length;
        if (!isBackspace && value.endsWith("{{")) {
            const variablePattern = /\{\{(\d+)\}\}/g;
            let matches = [...value.matchAll(variablePattern)].map((m) => parseInt(m[1]));
            let nextNumber = matches.length > 0 ? Math.max(...matches) + 1 : 1;
            newText = value + `${nextNumber}}}`;
        }
        handleChangeValue('bodyError', validateMessage(newText, state));
        handleChangeValue('body.text', newText);
        extractPlaceholdersForBody(newText)
        prevTextRef.current = newText;
    };
    const extractPlaceholdersForBody = (input) => {
        let matches;
        if (state.variable === 'POSITIONAL') {
            matches = input.match(/\{\{[1-9]\}\}/g);
        } else {
            matches = input.match(/\{\{[a-zA-Z_][a-zA-Z0-9_]*\}\}/g);
        }
        const bodyplaceholder = state?.bodyplaceholder || []
        handleChangeValue('bodyplaceholder', matches?.map(match => {
            const check = bodyplaceholder.find((it) => it?.key == match)
            if (check) {
                return check
            }
            return { key: match, value: "", type: "STATIC", dynamic_Key: "", display_name: "" }
        }) || [])
    };
    const textAreaRef = useRef(null);
    const wrapTextWithAsterisks = (sign) => {
        const textArea = textAreaRef.current;
        const start = textArea.selectionStart;
        const end = textArea.selectionEnd;
        if (start === end) return;
        const selectedText = state?.body?.text.substring(start, end);
        const newText = state?.body?.text.substring(0, start) + `${sign}${selectedText}${sign}` + state?.body?.text.substring(end);
        handleChangeValue('body.text', newText);
        setTimeout(() => {
            textArea.focus();
            textArea.selectionStart = start;
            textArea.selectionEnd = end + 2;
        }, 0);
    };
    const [category, setCategory] = useState([])
    const [language, setLanguage] = useState([])
    const [metaAccounts, setMetaAccounts] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            const data = await getCampianCategory(user)
            setCategory(data.reverse())
            const response = await getCampianLanguages(user)
            setLanguage(response)
            if (!location.state) {
                handleChangeValue('template', data[0]?._id)
                handleChangeValue('language', response[0]?._id)
            }
        }

        fetchData()
    }, [])
    useEffect(() => {
        const fetchData = async () => {
            if (selectGroup?._id) {
                const res = await getMetaAccount(user, selectGroup?._id)
                setMetaAccounts(res)
            }
        }

        fetchData()
    }, [selectGroup])
    useEffect(() => {
        if (template_feilds) {
            handleChangeValue('template_feilds', template_feilds)
        }
    }, [template_feilds])

    const [loadingBtn, setLoadingBtn] = useState(false)
    const [currEvent, setCurrEvent] = useState();
    const [eventsList, setEventsList] = useState([]);
    const [selectPackage, setSelectPackage] = useState()
    const [currEvent1, setCurrEvent1] = useState();
    const handleSubmit = async () => {
        try {
            const { meta_acc_id, name, language, template, header, body, bodyplaceholder, visiteButton, footerText, vendorId, phone_number, headerError, bodyError, template_id } = state
            const { text, example, format } = header

            if (!selectGroup) {
                return notify('Please select group name.')
            }

            if (!meta_acc_id) {
                return notify('Please select meta account.')
            }
            if (!name.trim()) {
                return notify('Please select template name.')
            }
            if (!language) {
                return notify('Please select language.')
            }

            if (!phone_number) {
                return notify('Please fill phone number.')
            }

            if (headerError) {
                return notify(headerError)
            }
            if (bodyError) {
                return notify(bodyError)
            }

            if (format == 'TEXT' && example?.type == "DYNAMIC") {
                if (!example?.dynamic_Key?.trim()) {
                    return notify('Please select field name in the header section.')
                }
                if (!example?.header_text?.trim() && text.includes("{{1}}")) {
                    return notify('Please fill header text in the header section.')
                }
            }
            if (format == 'TEXT' && example?.type == "STATIC") {
                if (!text?.trim()) {
                    return notify('Please fill header section.')
                }
                if (!example?.display_name?.trim() && text.includes("{{1}}")) {
                    return notify('Please fill display name in the header section.')
                }
                if (!example?.header_text?.trim() && text.includes("{{1}}")) {
                    return notify('Please fill header text in the header section.')
                }

            }

            if (header?.format == 'IMAGE') {
                if (!example?.header_handle?.trim()) {
                    return notify('Please select image in the header section.')
                }
            }
            if (header?.format == 'VIDEO') {
                if (!example?.header_handle?.trim()) {
                    return notify('Please select video in the header section.')
                }
            }
            if (!body.text?.trim()) {
                return notify("Body is required.")
            }

            if (bodyplaceholder.length) {
                for (let i = 0; i < bodyplaceholder?.length; i++) {
                    const element = bodyplaceholder[i];

                    if (element?.type == 'DYNAMIC') {
                        if (!element?.dynamic_Key?.trim()) {
                            return notify(`Please select a field name in the body section for key: ${element?.key}.`);
                        }
                    }

                    if (element?.type == 'STATIC') {
                        if (!element?.display_name?.trim()) {
                            return notify(`Please fill the display name in the body section for key: ${element?.key}.`);
                        }
                    }

                    if (!element?.value?.trim()) {
                        return notify(`Please fill the example value in the body section for key: ${element?.key}.`);
                    }
                }
            }

            const buttons = visiteButton.filter((it) => it?.status)

            for (let i = 0; i < buttons.length; i++) {
                const element = buttons[i];

                if (element?.buttonType == 'URL') {
                    if (element?.type == 'DYNAMIC') {
                        if (!element?.example?.header_text.trim()) {
                            return notify('Please add sample for website url.');
                        }
                    }
                    if (element?.type == 'DYNAMIC') {
                        if (!element?.display_name.trim()) {
                            return notify('Please add display name for the button.');
                        }
                    }
                    if (element?.type == 'STATIC') {
                        if (element.ButtonText == "RSVP") {
                            if (!element?.staticValue?.trim()) {
                                return notify('Please add phone number.');
                            }
                        }
                        if (element.ButtonText == "WhatsApp") {
                            if (!element?.staticValue?.trim()) {
                                return notify('Please add whatsapp number.');
                            }
                        }
                        if (element.ButtonText == "Event Link") {
                            if (!element?.staticValue?.trim()) {
                                return notify('Please Select Event.');
                            }
                        }
                    }
                }

                if (element?.buttonType == "PHONE_NUMBER") {
                    if (!element?.phone_number) {
                        return notify('Please add phone number.');
                    }
                    if (element?.phone_number.length != 12) {
                        return notify('Phone number must be 12 digits, including the country code (91).');
                    }
                }

                if (element?.buttonType == "COPY_CODE") {
                    if (!element?.code) {
                        return notify('Please add Offer code.');
                    }
                }
                if (element?.buttonType == "GUEST") {
                    if (!element?.staticValue.trim()) {
                        return notify('Please select event.');
                    }
                    if (!element.package) {
                        return notify('Please select package.');
                    }
                }

                if (!element?.text?.trim()) {
                    return notify('Please add button text.');
                }
            }


            let variable = {
                header: [],
                body: [],
                button: []
            }
            if (header?.format == 'NONE') {
                variable = {
                    ...variable,
                    header: []
                }
            }
            if (header?.format == 'TEXT') {

                variable = {
                    ...variable,
                    header: extractPlaceholders(state?.header?.text, state)?.map((it) => {
                        return {
                            key_value: getNumberFromString(it) || it.replace(/[{}]/g, "") || null,
                            type: example?.type,
                            value: example?.display_name || null,
                            feild_name: example?.dynamic_Key || null,
                            fallback_value: example?.header_text,
                            formate: header?.format
                        }
                    }),
                }


            }

            if (header?.format == 'IMAGE') {

                variable = {
                    ...variable,
                    header: [{
                        key_value: '1',
                        value: "Image",
                        type: "STATIC",
                        feild_name: null,
                        fallback_value: null,
                        formate: header?.format
                    }],

                }
            }
            if (header?.format == 'VIDEO') {

                variable = {
                    ...variable,
                    header: [{
                        key_value: '1',
                        value: "Video",
                        type: "STATIC",
                        feild_name: null,
                        fallback_value: null,
                        formate: header?.format
                    }],

                }
            }



            if (bodyplaceholder.length) {
                variable = {
                    ...variable,
                    body: bodyplaceholder.map((it) => {
                        return {
                            key_value: (state.variable == "POSITIONAL") ? getNumberFromString(it?.key) : it.key.replace(/[{}]/g, "") || null,
                            type: it?.type,
                            value: it?.display_name || null,
                            feild_name: it?.dynamic_Key || null,
                            fallback_value: it?.value
                        }
                    })

                }

            }

            if (buttons.length) {
                variable = {
                    ...variable,
                    button: buttons.map((it) => {
                        return {
                            key_value: '1',
                            type: it?.type || null,
                            value: it?.text || null,
                            feild_name: it?.display_name || null,
                            fallback_value: it?.example?.header_text || null,
                            isStatus: it.status,
                            label: it.label,
                            buttonType: it.buttonType,
                            staticValue: it.staticValue,
                            ButtonText: it.ButtonText,
                            event_id: it.event_id,
                            package: it.package
                        }
                    })

                }

            }

            let componentHeader = {
                meta_type: "HEADER",
                format: format,

            }
            if (format == 'TEXT') {
                if (state.variable == "POSITIONAL") {
                    componentHeader = {
                        ...componentHeader,
                        text: text,
                        example: {
                            header_text: [
                                example?.header_text
                            ]
                        }

                    }
                } else {

                    componentHeader = {
                        ...componentHeader,
                        text: text,
                        example: {
                            header_text_named_params: [
                                { param_name: extractPlaceholders(state?.header?.text, state)[0].replace(/[{}]/g, ""), example: example?.header_text }
                            ]
                        }

                    }
                }
            }
            if (format == 'VIDEO') {
                componentHeader = {
                    ...componentHeader,
                    example: {
                        header_handle: [
                            example?.header_handle
                        ]
                    }

                }
            }
            if (format == "IMAGE") {
                componentHeader = {
                    ...componentHeader,
                    example: {
                        header_handle: [
                            example?.header_handle
                        ]
                    }

                }
            }
            if (format == 'NONE') {
                componentHeader = null
            }

            let componentBody = {
                meta_type: "BODY",
                text: body?.text
            }
            if (bodyplaceholder.length) {
                if (state.variable == "POSITIONAL") {
                    componentBody = {
                        ...componentBody,
                        example: {
                            body_text: [
                                [
                                    ...bodyplaceholder.map((it) => it?.value)
                                ]
                            ]
                        }
                    }
                } else {
                    componentBody = {
                        ...componentBody,
                        example: {
                            body_text_named_params: [
                                ...bodyplaceholder.map((it) => ({ param_name: it.key.replace(/[{}]/g, ""), example: it?.value }))
                            ]
                        }
                    }
                }

            }
            let componentFooter = {
                meta_type: "FOOTER",
                text: footerText
            }
            if (!footerText) {
                componentFooter = null
            }
            let componentButtons = {
                meta_type: "BUTTONS",
                buttons: buttons.length ? buttons.map((it) => {
                    if (it?.buttonType == 'URL' && it?.type == 'DYNAMIC') {
                        return {
                            type: "URL",
                            text: it?.text,
                            url: it?.url,
                            example: [
                                it?.example?.header_text
                            ]
                        }
                    }
                    if (it?.buttonType == 'URL') {
                        return {
                            type: "URL",
                            text: it?.text,
                            url: it?.url + it.staticValue,
                        }
                    }
                    if (it?.buttonType == 'PHONE_NUMBER') {
                        return {
                            type: "PHONE_NUMBER",
                            text: it?.text,
                            phone_number: `${it?.phone_number}`,
                        }
                    }
                    if (it?.buttonType == 'COPY_CODE') {
                        return {
                            type: "CODE",
                            example: it?.code,
                        }
                    }
                    if (it?.buttonType == 'QUICK_REPLY') {
                        return {
                            type: "QUICK_REPLY",
                            text: it?.text || "Chat with us",
                        }
                    }
                    if (it?.buttonType == 'GUEST') {
                        return {
                            type: "QUICK_REPLY",
                            text: it.text
                        }
                    }
                }) : []
            }
            if (!componentButtons.buttons.length) {
                componentButtons = null

            }

            let data = {
                meta_acc_id: meta_acc_id,
                name: name,
                vendor_id: vendorId || undefined,
                meta_phone_number_id: phone_number,
                language: language,
                category: template,
                parameter_format: state.variable,
                variables: JSON.stringify(variable),
                components: [
                    componentHeader,
                    componentBody,
                    componentFooter,
                    componentButtons
                ].filter(Boolean),
                template_id: template_id,
                group: selectGroup?._id
            }
            const isPackage = selectPackage ? true : false
            if (isPackage) {
                let key = selectPackage.wa_qr_handle
                if (!selectPackage.wa_qr_handle) {
                    const res = await handleGenerateQr()
                    key = res.handle
                }

                data = {
                    ...data,
                    wa_qr_handle: key
                }
            }
            console.log(data);
            console.log(variable);
            let response
            setLoadingBtn(true)
            if (location?.state) {
                response = await updateTemplate(user, data)

            } else {
                response = await createCampiantemplate(user, data)
            }
            if (response) {
                navigate(-1)
                notify(response?.message, "success")
            }
        } catch (err) {
            console.log(err);

        } finally {
            setLoadingBtn(false)
        }

    }

    const handleGenerateQr = async () => {
        const event = state.visiteButton.find((it) => it.label == "Join As Guest")
        if (!selectPackage?.package_map_id || !event.package) {
            return notify('Package is required.')
        }
        try {
            setLoading(true)
            const data = await createQrCode(user, { event: currEvent1 || event.event_id, package_map_id: selectPackage?.package_map_id || event.package }, logout)
            if (data) {
                const response = await getZeroPackages(user, currEvent1 || event.event_id)
                setPackages(response || [])
                const newData = response.find((it) => it.package_map_id == data?.package_map_id)
                setSelectPackage(newData)
            }
            return data
        } catch (er) {
            console.log(er);
            return false
        } finally {
            setLoading(false)
        }

    }



    useEffect(() => {
        const fetchData = async () => {
            const data = await getCampianAssignVendorGroups(user, 0, 100000, "", "created", state?.meta_acc_id)
            handleChangeValue('assign_number', data)
        }
        if (state?.meta_acc_id) {
            fetchData()
        }
    }, [state?.meta_acc_id])
    const [loadingBack, setLoadingBack] = useState(location.state ? true : false)

    const { open: isOpen, handleCloseModal, handleOpenModal } = useModalControl()
    const emojiPickerRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
                handleCloseModal();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const fetchGroups = async () => {
            const data = await getCampianGroups(user, 0, 300, "")
            setGroupNames(data._payload);
        }
        fetchGroups()
    }, [])


    useEffect(() => {
        const fetchData = async () => {
            const data = await getLiveAndUpcomingEvents(user, "1,2", state.vendorId);
            setEventsList(data?._payload);
        }

        fetchData()
    }, [location.state, state.vendorId])

    const [packages, setPackages] = useState([])
    useEffect(() => {
        const event = state.visiteButton.find((it) => it.label == "Join As Guest")
        const fetchData = async () => {
            const response = await getZeroPackages(user, currEvent1 || event.event_id)
            setPackages(response || [])
        }
        if (currEvent1 || event.event_id) {
            fetchData()
        }

    }, [currEvent1, location.state, loadingBack])
    useEffect(() => {
        if (location?.state && category?.length && language?.length && template_feilds?.length && vendors?.length && groupNames?.length && eventsList.length) {
            const groupData = groupNames.find((it) => it._id == location.state?.wa_grp)
            setSelectGroup(groupData)
            handleChangeValue('edit', location.state)
            setLoadingBack(false)
        }
    }, [location.state, category, language, template_feilds, vendors, eventsList.length, packages.length])

    const handleAddVariable = (field) => {
        if (state.variable === 'POSITIONAL') {
            handleAddPositionalVariable(field);
        } else {
            handleAddNamedVariable(field);
        }
    };

    const handleAddPositionalVariable = (field) => {
        const variablePattern = /\{\{(\d+)\}\}/g;
        let text = field === 'header' ? state.header.text : state.body.text;
        let matches = [...text.matchAll(variablePattern)].map((m) => parseInt(m[1]));
        let nextNumber = matches.length > 0 ? Math.max(...matches) + 1 : 1;
        let newText = text + ` {{${nextNumber}}}`;

        if (field === 'header') {
            handleChangeValue('header.text', newText);
        } else {
            handleChangeValue('body.text', newText);
            extractPlaceholdersForBody(newText);
        }
    };

    const handleAddNamedVariable = (field) => {
        const variableTypes = {
            NAMED: [
                'user', "vendor", "customer"
            ],
        };

        // Get the appropriate variable list based on type
        const variableList = variableTypes[state.variable];

        // Find the next available variable name
        let text = field === 'header' ? state.header.text : state.body.text;
        const existingVariables = [];

        // Extract existing variables from text
        const variablePattern = /\{\{([a-zA-Z_][a-zA-Z0-9_]*)\}\}/g;
        const matches = [...text.matchAll(variablePattern)];
        matches.forEach(match => existingVariables.push(match[1]));

        // Find the next variable that doesn't exist yet
        let nextVariable = null;
        for (const variable of variableList) {
            if (!existingVariables.includes(variable)) {
                nextVariable = variable;
                break;
            }
        }

        // If all variables are used, use the first one with a number suffix
        if (!nextVariable) {
            let counter = 1;
            while (!nextVariable) {
                const candidate = `${variableList[0]}_${counter}`;
                if (!existingVariables.includes(candidate)) {
                    nextVariable = candidate;
                }
                counter++;
            }
        }

        const newText = text + ` {{${nextVariable}}}`;

        if (field === 'header') {
            handleChangeValue('header.text', newText);
        } else {
            handleChangeValue('body.text', newText);
            extractPlaceholdersForBody(newText);
            handleChangeValue('bodyError', validateMessage(newText, state));
        }
    };


    console.log(state, "=========>>>>>>>");

    let isEdit = location.state ? true : false
    return (
        <div style={{ position: "relative" }}  >
            {loadingBack && <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000000 }}
                open={loadingBack}
            >
                <CircularProgress color="inherit" />
            </Backdrop>}
            <Container maxWidth={themeStretch ? false : 'lg'}>
                <Stack spacing={2} direction="row" alignItems="center" mb="10px" >
                    <IconButton color="primary" onClick={() => navigate("/dashboard/campaign/template", { state: location?.state?.isreadOnly })}>
                        <ArrowBackIcon sx={{ fontSize: "30px" }} />
                    </IconButton>
                    <Typography variant="h3">
                        {
                            location?.state ?
                                "Update Template" : "Create New Template"
                        }

                    </Typography>
                </Stack>

                <Grid container >
                    <Grid item xs={12} md={8}>
                        <Grid container spacing={1} alignItems="center">
                            {location?.state && <Grid item xs={12} >
                                <Paper sx={{ display: "flex", padding: "10px", flexDirection: "column" }} >
                                    <Typography variant='h6'>Status</Typography>
                                    <FormControl>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            onChange={async (e) => {
                                                handleChangeValue('template_status', e.target.value)
                                                if (location?.state) {
                                                    const data = await updateTemplateStatus(user, { status: e.target.value, template_id: location.state.meta_template_id })
                                                    if (data) {
                                                        notify("Status Update successfully.", "success")
                                                    }
                                                }
                                            }}
                                            value={state.template_status}
                                        >
                                            <FormControlLabel value="0" control={<Radio />} label="Active" />
                                            <FormControlLabel value="1" control={<Radio />} label="In Active" />

                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                            </Grid>}
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} >
                                        <Grid item xs={12}>
                                            <Stack spacing={1}>
                                                <Typography>Add Template </Typography>


                                                <CustomInput
                                                    label="Select Group Name"
                                                    input={
                                                        <Select fullWidth displayEmpty
                                                            value={selectGroup?._id || ""}
                                                            disabled={isEdit}
                                                            onChange={(e) => {
                                                                const data = groupNames.find((it) => it._id == e.target.value)
                                                                setSelectGroup(data)

                                                                if (data?.vendorsData?.length) {
                                                                    setVendorRecords(data?.vendorsData)
                                                                } else {
                                                                    setVendorRecords(vendors)
                                                                }
                                                                handleChangeValue('vendorType', "all")
                                                                handleChangeValue('meta_acc_id', "")
                                                                handleChangeValue('phone_number', "")
                                                            }}
                                                        >
                                                            <MenuItem value={""}>Select Group Name</MenuItem>
                                                            {
                                                                groupNames?.map((it) => {
                                                                    return (
                                                                        <MenuItem key={it._id} value={it._id}>{it.name}</MenuItem>
                                                                    )
                                                                })
                                                            }
                                                        </Select>
                                                    }
                                                />
                                                {selectGroup?._id && <FormControl>
                                                    <RadioGroup
                                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                        name="controlled-radio-buttons-group"
                                                        value={state?.vendorType}
                                                        size="small"
                                                        disabled={isEdit}
                                                        onChange={(e) => handleChangeValue('vendorType', e.target.value)}
                                                    >
                                                        <FormControlLabel value="all" control={<Radio disabled={isEdit} />} label="Same for all Vendors" />
                                                        <FormControlLabel
                                                            value="individual"
                                                            control={<Radio disabled={isEdit} />}
                                                            label="Only for Individual"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>}
                                            </Stack>
                                        </Grid>
                                        {state?.vendorType === 'individual' && <Grid item xs={12} >
                                            <Stack spacing={1}>
                                                <Typography variant="h6">Select Vendors</Typography>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Vendors</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={state?.vendorId}
                                                        disabled={isEdit}
                                                        onChange={(e) => handleChangeValue('vendorId', e.target.value)}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                sx: {
                                                                    maxHeight: 320,
                                                                    maxWidth: 170,
                                                                    overflow: 'scroll',
                                                                    mt: 2,
                                                                    '&::-webkit-scrollbar': {
                                                                        width: '10px',
                                                                    },
                                                                    '&::-webkit-scrollbar-thumb': {
                                                                        backgroundColor: '#0276E5',
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                        label="Vendors"
                                                    >
                                                        <MenuItem disableRipple>
                                                            <TextField
                                                                fullWidth
                                                                variant="outlined"
                                                                size="small"
                                                                placeholder="Search Vendors"
                                                                onChange={handleVendorSearch}
                                                                onClick={(e) => e.stopPropagation()}
                                                                onKeyDown={(e) => e.stopPropagation()}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <Box
                                                                                component="img"
                                                                                src={searchIcon}
                                                                                alt="Search Icon"
                                                                                sx={{ width: 30, height: 30 }}
                                                                            />
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        </MenuItem>
                                                        {loading && (
                                                            <MenuItem disableRipple sx={{ display: "flex", justifyContent: "center" }}>
                                                                <CircularProgress size={24} />
                                                            </MenuItem>
                                                        )}

                                                        {!loading && filterdVendor?.length > 0 && (
                                                            filterdVendor.map((data) => (
                                                                <MenuItem key={data._id} value={data._id}>
                                                                    <span dangerouslySetInnerHTML={{ __html: highlightText(data.name, search) }} />
                                                                </MenuItem>
                                                            ))
                                                        )}

                                                        {!loading && (!filterdVendor || filterdVendor.length === 0) && (
                                                            <MenuItem disableRipple sx={{ display: "flex", justifyContent: "center" }}>
                                                                No data found
                                                            </MenuItem>
                                                        )}

                                                    </Select>
                                                </FormControl>
                                            </Stack>
                                        </Grid>}
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">

                                        <Grid item xs={12} >
                                            <Stack spacing={1} marginBottom="4px">
                                                <Typography variant="h6">Set up your template <sup style={{ color: "red" }}>*</sup></Typography>
                                                <FormControl>
                                                    <RadioGroup
                                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                        name="controlled-radio-buttons-group"
                                                        value={state?.template}
                                                        size="small"

                                                        onChange={(e) => handleChangeValue('template', e.target.value)}
                                                    >
                                                        {
                                                            category?.map((it) => {
                                                                return (

                                                                    <FormControlLabel key={it?._id} value={it?._id} control={<Radio disabled={isEdit} />} label={it?.handle} />
                                                                )
                                                            })
                                                        }
                                                    </RadioGroup>
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Stack spacing={1} marginBottom="4px" direction="row" alignItems="self-start">
                                                <Box sx={{ padding: "8px 12px", background: "#4dbba6", borderRadius: "6px" }}>
                                                    <CampaignIcon sx={{ fontSize: "30px" }} />
                                                </Box>
                                                <Stack spacing={.5}>
                                                    <Stack direction="row" gap={1}>
                                                        <Typography variant='body1'>{state?.name ? state?.name : 'your_template_name'} </Typography>
                                                        <Typography variant='body1'>|</Typography>
                                                        <Typography variant='body1'>English</Typography>
                                                    </Stack>
                                                    <Stack direction="row" gap={1}>
                                                        <Typography variant="caption" sx={{ color: "#ffffff50" }}>
                                                            {
                                                                category?.find((it) => it?._id == state?.template)?.handle
                                                            }
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: "#ffffff50" }}>|</Typography>
                                                        <Typography variant="caption" sx={{ color: "#ffffff50" }}>Custom</Typography>
                                                    </Stack>
                                                </Stack>


                                            </Stack>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} md={6}>
                                                    <Stack spacing={1} marginBottom="4px" >
                                                        <Typography variant="body1">Select Meta Account <sup style={{ color: "red" }}>*</sup></Typography>
                                                        <FormControl fullWidth>
                                                            <InputLabel id="demo-simple-select-label">Select Meta Account</InputLabel>
                                                            <Select fullWidth
                                                                value={state?.meta_acc_id}
                                                                disabled={isEdit}
                                                                onChange={(e) => handleChangeValue('meta_acc_id', e.target.value)}
                                                                select
                                                                label="Select Meta Account"
                                                            >
                                                                {
                                                                    metaAccounts?.map((it) => {
                                                                        return (

                                                                            <MenuItem value={it?.id}>{it?.name}</MenuItem>
                                                                        )
                                                                    })
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Stack>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Stack spacing={1} marginBottom="4px" >
                                                        <Typography variant="body1">Meta Template Phone Number <sup style={{ color: "red" }}>*</sup></Typography>
                                                        <FormControl fullWidth>
                                                            <InputLabel id="demo-simple-select-label">Meta Template Phone Number</InputLabel>
                                                            <Select fullWidth
                                                                value={state?.phone_number}
                                                                onChange={(e) => handleChangeValue('phone_number', e.target.value)}
                                                                select
                                                                disabled={isEdit}
                                                                label="Meta Template Phone Number"
                                                            >
                                                                {
                                                                    state?.assign_number?.map((it) => {
                                                                        return (

                                                                            <MenuItem value={it?.phone_number_id}>{it?.display_number}</MenuItem>
                                                                        )
                                                                    })
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Stack>
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <Stack spacing={1} marginBottom="4px" >
                                                        <Typography variant="body1">Type Of Variable <sup style={{ color: "red" }}>*</sup></Typography>
                                                        <FormControl fullWidth>
                                                            <Select fullWidth
                                                                disabled={isRead || isEdit}
                                                                value={state?.variable}
                                                                onChange={(e) => {
                                                                    handleChangeValue('variable', e.target.value)
                                                                    handleChangeValue('header.example?.type', "STATIC")
                                                                    handleChangeValue('bodyError', "");
                                                                    handleChangeValue('header.format', "NONE")
                                                                    handleChangeValue('header.text', '')
                                                                    handleChangeValue('body.text', "Hello");
                                                                }}
                                                                displayEmpty
                                                            >
                                                                {
                                                                    [{ label: "Number", value: "POSITIONAL" }, { label: "Name", value: "NAMED" }]?.map((it) => {
                                                                        return (
                                                                            <MenuItem value={it?.value}>{it?.label}</MenuItem>
                                                                        )
                                                                    })
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Stack>
                                                </Grid>


                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">

                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Template name and language <sup style={{ color: "red" }}>*</sup></Typography>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Stack spacing={1} marginBottom="4px">
                                                <Typography variant="body1">Templete Name <sup style={{ color: "red" }}>*</sup></Typography>
                                                <TextField fullWidth placeholder='Enter a templete name.'
                                                    value={state?.name}
                                                    onChange={(e) => handleChangeValue('name', e.target.value)}
                                                    inputProps={{ maxLength: 512 }}
                                                    disabled={isEdit}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                <Typography sx={{ fontSize: "14px" }}>
                                                                    {state?.name?.length}/512
                                                                </Typography>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Stack spacing={1} marginBottom="4px">
                                                <Typography variant="body1">Select language <sup style={{ color: "red" }}>*</sup></Typography>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Select language</InputLabel>
                                                    <Select fullWidth placeholder='Enter a templete name.'
                                                        value={state?.language}
                                                        onChange={(e) => handleChangeValue('language', e.target.value)}
                                                        select
                                                        // disabled={isEdit}
                                                        disabled
                                                        label="Select language"
                                                    >
                                                        {
                                                            language?.map((it) => {
                                                                return (

                                                                    <MenuItem value={it?._id}>{it?.name}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">

                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Content <sup style={{ color: "red" }}>*</sup></Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Stack spacing={1} marginBottom="4px">
                                                <Typography variant="body1">Header (Optional)</Typography>
                                                <FormControl>
                                                    <RadioGroup
                                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                        name="controlled-radio-buttons-group"
                                                        value={state?.header?.format}
                                                        size="small"
                                                        onChange={(e) => handleChangeValue('header.format', e.target.value)}
                                                    >
                                                        <FormControlLabel value="NONE" control={<Radio disabled={isRead} />} label="None" />
                                                        <FormControlLabel
                                                            value="TEXT"
                                                            control={<Radio disabled={isRead} />}
                                                            label="Text"
                                                        />
                                                        <FormControlLabel
                                                            value="VIDEO"
                                                            control={<Radio disabled={isRead} />}
                                                            label="Video"
                                                        />
                                                        <FormControlLabel
                                                            value="IMAGE"
                                                            control={<Radio disabled={isRead} />}
                                                            label="Image"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        {state?.header?.format === 'TEXT' && <Grid item xs={12} >
                                            <TextField placeholder='Enter text in English' fullWidth
                                                value={state?.header?.text}
                                                onChange={(e) => handleChangeValue('header.text', e.target.value)}
                                                inputProps={{ maxLength: 60 }}
                                                disabled={isRead}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="start">
                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                {state?.header?.text?.length}/60
                                                            </Typography>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                error={!!state?.headerError}
                                                // error={true}
                                                helperText={state?.headerError}
                                            />
                                            <Stack direction="row" justifyContent="flex-end" marginTop="10px">
                                                <Button startIcon={<AddIcon />}
                                                    disabled={
                                                        (state.variable === 'POSITIONAL' && state?.header?.text?.includes('{{1}}')) ||
                                                        (state.variable === 'NAMED' && state?.header?.text?.includes('{{'))
                                                    }
                                                    variant="contained"
                                                    onClick={() => handleAddVariable('header')}
                                                >

                                                    Add {state.variable === 'POSITIONAL' ? 'Number' : 'Named'} Variable
                                                </Button>
                                            </Stack>

                                            {(extractPlaceholders(state?.header?.text, state).length > 0 && !state?.headerError) && extractPlaceholders(state?.header?.text, state).map((it) => {
                                                return (
                                                    <Stack key={it}>
                                                        <Typography variant="h6">Samples for header content</Typography>
                                                        <FormControl>
                                                            <RadioGroup
                                                                sx={{ display: 'flex', flexDirection: 'row' }}
                                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                                name="controlled-radio-buttons-group"
                                                                value={state?.header.example?.type}
                                                                size="small"
                                                                onChange={(e) => handleChangeValue('header.example?.type', e.target.value)}
                                                            >
                                                                <FormControlLabel value="STATIC" control={<Radio disabled={isRead} />} label="Static" />
                                                                <FormControlLabel value="DYNAMIC" control={<Radio disabled={isRead} />} label="Dynamic" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                        {state?.header.example?.type == 'DYNAMIC' && <>
                                                            <Typography variant="h6">Select Field Name</Typography>

                                                            <FormControl>
                                                                <RadioGroup
                                                                    sx={{ display: 'flex', flexDirection: 'row' }}
                                                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                                                    name="controlled-radio-buttons-group"
                                                                    value={state?.header.example?.dynamic_Key}
                                                                    size="small"
                                                                    onChange={(e) => handleChangeValue('header.example?.dynamic_Key', e.target.value)}
                                                                >
                                                                    {
                                                                        template_feilds?.map((it) => {
                                                                            return (
                                                                                <FormControlLabel value={it?._id} key={it?._id} control={<Radio disabled={isRead} />} label={it?.name} />
                                                                            )
                                                                        })
                                                                    }
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </>
                                                        }
                                                        {state?.header.example?.type == 'STATIC' && <Box sx={{ margin: "0 0 10px 0px" }}>
                                                            <Typography variant="body2">Display Name</Typography>

                                                            <TextField
                                                                fullWidth
                                                                value={state?.header.example?.display_name}
                                                                onChange={(e) => handleChangeValue('header.example?.display_name', e.target.value)}
                                                                placeholder="Enter display name."
                                                                disabled={isRead}
                                                            />
                                                        </Box>
                                                        }

                                                        <Stack direction="row" alignItems="center" gap={1}>
                                                            <Typography variant="body2">{it}</Typography>
                                                            <TextField fullWidth placeholder={`Enter content for ${it}`}
                                                                value={state?.header?.example?.header_text}
                                                                onChange={(e) => handleChangeValue('header.example.header_text', e.target.value)}
                                                                disabled={state?.header.example?.type != 'STATIC' || isRead}
                                                            />
                                                        </Stack>

                                                    </Stack>
                                                )
                                            })}
                                        </Grid>}
                                        {state?.header?.format === 'IMAGE' && <Grid item xs={12} >
                                            <Stack direction="row" gap={1} alignItems="center">
                                                <Typography>Image</Typography>

                                                {!state?.selectedImage ? <label htmlFor="upload-image">
                                                    <Button startIcon={<CropOriginalIcon />} variant="contained" component="span" disabled={isRead}>
                                                        Choose JPG or PNG file
                                                    </Button>
                                                </label> : <Stack direction="row" alignItems="center" gap="5px" sx={{ padding: "5px 15px", border: "1px solid lightGrey", borderRadius: "6px" }}>
                                                    <img src={state?.selectedImage} alt="Selected" width="30" />
                                                    <Typography sx={{ fontSize: "14px" }} variant="caption">{imagePath?.name || 'Sample Image'}</Typography>
                                                    <IconButton onClick={() => handleRemoveImage()} disabled={isRead}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                    {
                                                        loadingUpload &&
                                                        <Box sx={{ display: 'flex', alignItems: "center", gap: "10px" }}>
                                                            <CircularProgress />
                                                            <Typography>Uploading...</Typography>
                                                        </Box>}
                                                </Stack>}

                                                <input
                                                    type="file"
                                                    accept="image/png, image/jpeg"
                                                    style={{ display: "none" }}
                                                    id="upload-image"
                                                    disabled={isRead}
                                                    onChange={handleImageChange}
                                                />
                                            </Stack>


                                        </Grid>}
                                        {state?.header?.format === 'VIDEO' && <Grid item xs={12} >
                                            <Stack direction="row" gap={1} alignItems="center">
                                                <Typography>Video</Typography>

                                                {!state?.selectedVideo ? <label htmlFor="upload-video">
                                                    <Button startIcon={<CropOriginalIcon />} variant="contained" component="span" disabled={isRead}>
                                                        Choose MP4 file
                                                    </Button>
                                                </label> : <Stack direction="row" alignItems="center" gap="5px" flexWrap="wrap" sx={{ padding: "0px 15px", border: "1px solid lightGrey", borderRadius: "6px" }}>
                                                    {/* <img src={state?.selectedImage} alt="Selected" width="30" /> */}
                                                    <video
                                                        width="80"
                                                        height="60"
                                                        controls
                                                        src={state.selectedVideo}
                                                    />
                                                    <Typography sx={{ fontSize: "14px" }} variant="caption">{videoPath?.name || 'Sample Video'}</Typography>
                                                    <IconButton onClick={() => handleRemoveVideo()} disabled={isRead}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                    {
                                                        loadingUpload && <Box sx={{ display: 'flex', alignItems: "center", gap: "10px" }}>
                                                            <CircularProgress />
                                                            <Typography>Uploading...</Typography>
                                                        </Box>}
                                                </Stack>}

                                                <input
                                                    type="file"
                                                    accept="video/mp4"
                                                    style={{ display: "none" }}
                                                    id="upload-video"
                                                    disabled={isRead}
                                                    onChange={handleVideoChange}
                                                />
                                            </Stack>


                                        </Grid>}
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">

                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Body <sup style={{ color: "red" }}>*</sup></Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <TextField multiline rows={6} placeholder='Enter text in English' fullWidth inputProps={{ maxLength: 1024 }}
                                                onChange={handleChange}
                                                value={state?.body?.text}
                                                error={state?.bodyError}
                                                helperText={state?.bodyError}
                                                inputRef={textAreaRef}
                                                disabled={isRead}
                                                id={`textField-1`}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end" sx={{ position: "relative", top: "-65px" }} >
                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                {state?.body?.text?.length}/1024
                                                            </Typography>
                                                        </InputAdornment>
                                                    ),
                                                }}

                                            />
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Stack direction="row" justifyContent="flex-end">
                                                <IconButton onClick={() => wrapTextWithAsterisks('*')} disabled={isRead}>
                                                    <FormatBoldIcon />
                                                </IconButton>
                                                <IconButton onClick={() => wrapTextWithAsterisks('_')} disabled={isRead}>
                                                    <FormatItalicIcon />
                                                </IconButton>
                                                <IconButton onClick={() => handleOpenModal()} disabled={isRead}>
                                                    <EmojiEmotions />
                                                </IconButton>
                                                {/* <Button startIcon={<AddIcon />} disabled={isRead} variant="contained" onClick={() => handleChangeValue('body.text.variable')}>Add Variable</Button> */}
                                                <Button startIcon={<AddIcon />} variant="contained"
                                                    // onClick={() => handleChangeValue('body.text.variable')}
                                                    onClick={() => handleAddVariable('body')}

                                                >
                                                    Add {state.variable === 'POSITIONAL' ? 'Number' : 'Named'} Variable
                                                </Button>

                                            </Stack>
                                            <Stack mt={2} ref={emojiPickerRef}>
                                                <EmojiPicker
                                                    width="100%"
                                                    open={isOpen}
                                                    onEmojiClick={(emoji) => {
                                                        const textField = document.getElementById(`textField-1`);
                                                        const currentValue = textField.value;
                                                        const selectionStart = textField.selectionStart;
                                                        const selectionEnd = textField.selectionEnd;
                                                        const newValue =
                                                            currentValue.substring(0, selectionStart) +
                                                            emoji.emoji +
                                                            currentValue.substring(selectionEnd);
                                                        textField.value = newValue;
                                                        textField.focus();
                                                        textField.setSelectionRange(
                                                            selectionStart + emoji.emoji.length,
                                                            selectionStart + emoji.emoji.length
                                                        );
                                                        handleChangeValue('body.text', newValue);

                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} >
                                            {
                                                ((!state?.bodyError && state?.bodyplaceholder?.length > 0) && state?.bodyplaceholder?.map((it, index) => {
                                                    return (
                                                        <Paper key={it?.key} sx={{ padding: "10px", border: "1px solid #ffffff50", marginBottom: "10px" }}>
                                                            <Stack marginTop="5px">
                                                                <Typography variant="h6">Samples for body content {it.key}:</Typography>
                                                                <FormControl>
                                                                    <RadioGroup
                                                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                                        name="controlled-radio-buttons-group"
                                                                        value={it?.type}
                                                                        size="small"

                                                                        onChange={(e) => handleChangeValue('bodyplaceholder.type', { key: it?.key, type: e.target.value })}
                                                                    >
                                                                        <FormControlLabel value="STATIC" control={<Radio disabled={isRead} />} label="Static" />
                                                                        <FormControlLabel value="DYNAMIC" control={<Radio disabled={isRead} />} label="Dynamic" />
                                                                    </RadioGroup>
                                                                </FormControl>
                                                                {it?.type == 'DYNAMIC' && <>
                                                                    <Typography variant="h6">Select Field Name</Typography>
                                                                    <FormControl>
                                                                        <RadioGroup
                                                                            sx={{ display: 'flex', flexDirection: 'row' }}
                                                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                                                            name="controlled-radio-buttons-group"
                                                                            size="small"
                                                                            value={it?.dynamic_Key}
                                                                            onChange={(e) => handleChangeValue('bodyplaceholder.dynamic_Key', { key: it?.key, dynamic_Key: e.target.value })}
                                                                        >
                                                                            {
                                                                                template_feilds?.map((it) => {
                                                                                    return (
                                                                                        <FormControlLabel value={it?._id} key={it?._id} control={<Radio disabled={isRead} />} label={it?.name} />
                                                                                    )
                                                                                })
                                                                            }
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                </>}
                                                                {it?.type == 'STATIC' && <Box sx={{ margin: "0 0 10px 0px" }}>
                                                                    <Typography variant="body2">Display Name</Typography>

                                                                    <TextField
                                                                        fullWidth
                                                                        value={it?.display_name}
                                                                        onChange={(e) => handleChangeValue('bodyplaceholder.display_name', { key: it?.key, display_name: e.target.value })}
                                                                        placeholder="Enter display name."
                                                                        disabled={isRead}
                                                                    />
                                                                </Box>
                                                                }
                                                                <Stack direction="row" alignItems="center" gap={1}>
                                                                    <Typography variant="body2">{it?.key}</Typography>
                                                                    <TextField fullWidth placeholder={`Enter content for ${it?.key}`}
                                                                        value={it?.value}
                                                                        disabled={isRead || it?.type == 'DYNAMIC'}

                                                                        onChange={(e) => handleChangeValue('bodyplaceholder.value', { key: it?.key, value: e.target.value })}
                                                                    />
                                                                </Stack>

                                                            </Stack>
                                                        </Paper>
                                                    )
                                                }))
                                            }
                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Footer (Optional)</Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <TextField placeholder='Enter text in English' fullWidth
                                                value={state?.footerText}
                                                onChange={(e) => handleChangeValue('footerText', e.target.value)}
                                                inputProps={{ maxLength: 60 }}
                                                disabled

                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="start">
                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                {state?.footerText?.length}/60
                                                            </Typography>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Buttons (Optional)</Typography>
                                            <Typography variant="caption" sx={{ fontWeight: "normal" }}>Create buttons that let customers respond to your message or take action. You can add up to one buttons.
                                                {/* If you add more than three buttons, they will appear in a list. */}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} >

                                            <FormGroup row>
                                                {
                                                    state?.visiteButton?.map((it, index) => {
                                                        return (
                                                            <FormControlLabel key={it?.label} control={<Checkbox disabled={isRead} checked={it?.status} onChange={(e) => handleChangeValue('visiteButton', { index, checked: e.target.checked })} />} label={it?.label} />
                                                        )
                                                    })
                                                }
                                            </FormGroup>


                                        </Grid>
                                        <Grid item xs={12} >

                                            <Stack spacing={1}>
                                                {
                                                    state?.visiteButton?.map((ite, index) => {
                                                        if (!ite?.status) {
                                                            return
                                                        }
                                                        if (ite?.label == "Chat with us" || ite?.label == "Donate Now") {
                                                            return
                                                        }
                                                        return (
                                                            <Paper sx={{ display: "flex", border: "1px solid #ffffff50", padding: "10px", flexDirection: "column" }} key={ite?.label}>
                                                                {['Other',].includes(ite?.label) && <FormControl>
                                                                    <RadioGroup
                                                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                                        name="controlled-radio-buttons-group"
                                                                        value={ite?.type}
                                                                        size="small"
                                                                        row
                                                                        onChange={(e) => handleChangeValue('visiteButton.type', { index, type: e.target.value, label: ite.label })}
                                                                    >
                                                                        <FormControlLabel value="STATIC" control={<Radio disabled={isRead} />} label="Static" />
                                                                        <FormControlLabel value="DYNAMIC" control={<Radio disabled={isRead} />} label="Dynamic" />
                                                                    </RadioGroup>
                                                                </FormControl>}
                                                                <Stack direction="row" gap={1} mb="10px">
                                                                    {['Other'].includes(ite?.label) && <CustomInput
                                                                        label="Button Type"
                                                                        input={
                                                                            <TextField size='small' disabled={ite?.label == 'Copy offer code' || isRead} fullWidth placeholder='Enter Type.'
                                                                                value={ite?.ButtonText}
                                                                                onChange={(e) => {
                                                                                    handleChangeValue('visiteButton.ButtonText', { index, text: e.target.value })
                                                                                    handleChangeValue('visiteButton.staticValue', { index, text: "" })
                                                                                    setCurrEvent("")
                                                                                    if (e.target.value == "Other") {
                                                                                        handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/{{1}}" })
                                                                                    } else if (e.target.value == "Event Link") {
                                                                                        if (ite?.type == "STATIC") {
                                                                                            handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/events/" })
                                                                                            handleChangeValue('visiteButton.display_name', { index, text: "" });
                                                                                            handleChangeValue('visiteButton.example.header_text', { index, header_text: "" })
                                                                                        } else {
                                                                                            handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/events/{{1}}" })
                                                                                            handleChangeValue('visiteButton.display_name', { index, text: "Select Event" });
                                                                                            handleChangeValue('visiteButton.example.header_text', { index, header_text: "event" })
                                                                                        }
                                                                                        handleChangeValue('visiteButton.text', { index, text: "Event Link" })
                                                                                    } else if (e.target.value == "RSVP") {
                                                                                        if (ite?.type == "STATIC") {
                                                                                            handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/rsvp?phoneNumber=" })
                                                                                        } else {
                                                                                            handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/rsvp?phoneNumber={{1}}" })
                                                                                        }
                                                                                        handleChangeValue('visiteButton.text', { index, text: "RSVP" })
                                                                                    } else if (e.target.value == "WhatsApp") {
                                                                                        if (ite?.type == "STATIC") {
                                                                                            handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/rsvp?wattsapp=" })
                                                                                            handleChangeValue('visiteButton.display_name', { index, text: "" });
                                                                                            handleChangeValue('visiteButton.example.header_text', { index, header_text: "" })
                                                                                        } else {
                                                                                            handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/rsvp?wattsapp={{1}}" })
                                                                                            handleChangeValue('visiteButton.display_name', { index, text: "Enter Whatsapp Number" });
                                                                                            handleChangeValue('visiteButton.example.header_text', { index, header_text: "whatsapp" })
                                                                                        }
                                                                                        handleChangeValue('visiteButton.text', { index, text: "WhatsApp" })
                                                                                    }
                                                                                }}
                                                                                inputProps={{ maxLength: 25 }}
                                                                                select
                                                                            >
                                                                                {/* <MenuItem value="Visit website">Visit website</MenuItem> */}
                                                                                <MenuItem value="Event Link">Event Link</MenuItem>
                                                                                {/* <MenuItem value="RSVP">RSVP</MenuItem> */}
                                                                                <MenuItem value="WhatsApp">WhatsApp</MenuItem>
                                                                            </TextField>
                                                                        }
                                                                    />}

                                                                    {/* 
                                                                    {['Other'].includes(ite?.label) && <CustomInput
                                                                        label="Website URL"
                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter text.'
                                                                                inputProps={{ maxLength: 2000 }}
                                                                                value={ite?.url}
                                                                                disabled

                                                                                onChange={(e) => handleChangeValue('visiteButton.url', { index, url: e.target.value })}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.url?.length}/2000
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />} */}
                                                                    {['Copy offer code'].includes(ite?.label) && <CustomInput
                                                                        label="Offer code"
                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter code.'
                                                                                inputProps={{ maxLength: 15 }}
                                                                                value={ite?.code}
                                                                                disabled={isRead}
                                                                                onChange={(e) => handleChangeValue('visiteButton.code', { index, code: e.target.value })}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.code?.length}/15
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />}
                                                                    {!['Other', 'Copy offer code', "Join As Guest"].includes(ite?.label) && <CustomInput
                                                                        label="Phone Number"

                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter number.'
                                                                                value={ite?.phone_number}
                                                                                onChange={(e) => handleChangeValue('visiteButton.phone_number', { index, phone_number: e.target.value })}
                                                                                inputProps={{ maxLength: 12 }}
                                                                                disabled={isRead}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.phone_number?.length}/12
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />}
                                                                    {(['RSVP'].includes(ite?.label) && ite?.type == "STATIC") && <CustomInput
                                                                        label="Button Text"
                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter text.'
                                                                                inputProps={{ maxLength: 20 }}
                                                                                value={ite?.text}
                                                                                disabled={isRead}
                                                                                onChange={(e) => handleChangeValue('visiteButton.text', { index, text: e.target.value })}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.text?.length}/20
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />}


                                                                    {/* {["Custom Quick Reply"].includes(ite?.label) && <CustomInput
                                                                        label="Add Text"

                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter text.'
                                                                                value={ite?.text}
                                                                                onChange={(e) => handleChangeValue('visiteButton.quick.text', { index, text: e.target.value })}
                                                                                inputProps={{ maxLength: 50 }}
                                                                                disabled={isRead}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.text?.length}/50
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />} */}
                                                                </Stack>
                                                                {/* {ite?.type == 'DYNAMIC' && <CustomInput
                                                                    label="Display Name"
                                                                    input={
                                                                        <Box sx={{ margin: "0 0 10px 0px" }}>
                                                                            <TextField
                                                                                fullWidth
                                                                                value={ite?.display_name}
                                                                                // onChange={(e) => handleChangeValue('bodyplaceholder.display_name', { key: it?.key, display_name: e.target.value })}
                                                                                onChange={(e) => {
                                                                                    handleChangeValue('visiteButton.display_name', { index, text: e.target.value });
                                                                                }}
                                                                                disabled={isRead}
                                                                                placeholder="Enter display name."
                                                                            />
                                                                        </Box>

                                                                    }
                                                                />}
                                                                {ite?.type == 'DYNAMIC' && <Stack direction="row" alignItems="center" gap={1} marginTop="10px">
                                                                    <Typography>{`{{1}}`}</Typography>
                                                                    <TextField
                                                                        placeholder='Enter text in English'
                                                                        size='small'
                                                                        value={ite?.example?.header_text}
                                                                        onChange={(e) => handleChangeValue('visiteButton.example.header_text', { index, header_text: e.target.value })}
                                                                        fullWidth
                                                                        disabled={isRead}
                                                                    />
                                                                </Stack>} */}
                                                                {(['Other',].includes(ite?.label)) && <Stack direction="row" gap="10px">
                                                                    <CustomInput
                                                                        label="Button Text"
                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter text.'
                                                                                inputProps={{ maxLength: 20 }}
                                                                                value={ite?.text}
                                                                                disabled={isRead}
                                                                                onChange={(e) => handleChangeValue('visiteButton.text', { index, text: e.target.value })}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.text?.length}/20
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />
                                                                    {(ite?.ButtonText == "Event Link" && ite?.type == "STATIC") && <CustomInput
                                                                        label="Event Link"
                                                                        input={
                                                                            <FormControl
                                                                                fullWidth
                                                                                size="small"
                                                                            >
                                                                                <Select
                                                                                    fullWidth
                                                                                    id="event-select"
                                                                                    disabled={isRead}
                                                                                    value={ite.event_id}
                                                                                    onChange={(e) => {
                                                                                        if (e.target.value) {
                                                                                            const eventData = eventsList.find((it) => it._id == e.target.value)
                                                                                            setCurrEvent(e.target.value);
                                                                                            handleChangeValue('visiteButton.staticValue', { index, text: eventData.handle })
                                                                                            handleChangeValue('visiteButton.event_id', { index, event_id: eventData._id })
                                                                                        } else {
                                                                                            handleChangeValue('visiteButton.event_id', { index, event_id: "" })
                                                                                            handleChangeValue('visiteButton.staticValue', { index, text: "" })

                                                                                        }
                                                                                    }}
                                                                                    MenuProps={{
                                                                                        PaperProps: {
                                                                                            sx: {
                                                                                                maxHeight: 320,
                                                                                                maxWidth: "100%",
                                                                                                overflowY: "auto",
                                                                                                "&::-webkit-scrollbar": {
                                                                                                    width: "2px",
                                                                                                },
                                                                                                "&::-webkit-scrollbar-thumb": {
                                                                                                    backgroundColor: "primary.main",
                                                                                                },
                                                                                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.4)",
                                                                                            },
                                                                                        },
                                                                                    }}
                                                                                >

                                                                                    {eventsList.map((item, index) => (
                                                                                        <MenuItem key={index} value={item._id} disableRipple>
                                                                                            <Box display="flex" alignItems="center">
                                                                                                <Box
                                                                                                    component="span"
                                                                                                    sx={{
                                                                                                        width: 8,
                                                                                                        height: 8,
                                                                                                        borderRadius: "50%",
                                                                                                        marginRight: 1,
                                                                                                        backgroundColor:
                                                                                                            item.event_status === 2
                                                                                                                ? "green"
                                                                                                                : item.event_status === 1
                                                                                                                    ? "orange"
                                                                                                                    : "red",
                                                                                                    }}
                                                                                                />
                                                                                                {truncateText(item.name, 24)}
                                                                                            </Box>
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </FormControl>
                                                                        }
                                                                    />}
                                                                    {(['RSVP'].includes(ite?.label) && ite?.type == "STATIC") && <CustomInput
                                                                        label="Add Phone Number"
                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter Phone Number..'
                                                                                inputProps={{ maxLength: 10 }}
                                                                                onKeyDown={handleKeyPress}
                                                                                value={ite?.staticValue}
                                                                                disabled={isRead}
                                                                                onChange={(e) => handleChangeValue('visiteButton.staticValue', { index, text: e.target.value })}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.staticValue?.length || 0}/10
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}

                                                                            />
                                                                        }
                                                                    />}

                                                                    {(ite?.ButtonText == "RSVP" && ite?.type == "STATIC") && <CustomInput
                                                                        label="Add Phone Number"
                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter Phone Number..'
                                                                                inputProps={{ maxLength: 10 }}
                                                                                onKeyDown={handleKeyPress}
                                                                                value={ite?.staticValue}
                                                                                disabled={isRead}
                                                                                onChange={(e) => handleChangeValue('visiteButton.staticValue', { index, text: e.target.value })}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.staticValue?.length || 0}/10
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}

                                                                            />
                                                                        }
                                                                    />}
                                                                    {(ite?.ButtonText == "WhatsApp" && ite?.type == "STATIC") && <CustomInput
                                                                        label="Add Whatsapp Number"
                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter WhatsApp Number.,.'
                                                                                value={ite?.staticValue}
                                                                                inputProps={{ maxLength: 10 }}
                                                                                onKeyDown={handleKeyPress}
                                                                                disabled={isRead}
                                                                                onChange={(e) => handleChangeValue('visiteButton.staticValue', { index, text: e.target.value })}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.staticValue?.length || 0}/10
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />}
                                                                </Stack>}
                                                                {['Join As Guest'].includes(ite?.label) && <Paper sx={{ border: 1, borderColor: "lightgrey", padding: "10px" }}>
                                                                    <Typography mb={2} variant="h5" color="primary">
                                                                        *Join As Guest*
                                                                    </Typography>
                                                                    <Stack direction="row" gap={1}>

                                                                        <CustomInput
                                                                            label="Event Link"
                                                                            input={
                                                                                <FormControl
                                                                                    fullWidth
                                                                                    size="small"
                                                                                >
                                                                                    <Select
                                                                                        fullWidth
                                                                                        id="event-select"
                                                                                        value={ite.event_id || ""}
                                                                                        disabled={isRead}
                                                                                        onChange={(e) => {
                                                                                            if (e.target.value) {
                                                                                                const eventData = eventsList.find((it) => it._id == e.target.value)
                                                                                                setCurrEvent1(e.target.value);
                                                                                                handleChangeValue('visiteButton.staticValue', { index, text: eventData.handle })
                                                                                                handleChangeValue('visiteButton.event_id', { index, event_id: eventData._id })
                                                                                            } else {
                                                                                                handleChangeValue('visiteButton.event_id', { index, event_id: "" })
                                                                                                handleChangeValue('visiteButton.staticValue', { index, text: "" })

                                                                                            }
                                                                                        }}
                                                                                        MenuProps={{
                                                                                            PaperProps: {
                                                                                                sx: {
                                                                                                    maxHeight: 320,
                                                                                                    maxWidth: "100%",
                                                                                                    overflowY: "auto",
                                                                                                    "&::-webkit-scrollbar": {
                                                                                                        width: "2px",
                                                                                                    },
                                                                                                    "&::-webkit-scrollbar-thumb": {
                                                                                                        backgroundColor: "primary.main",
                                                                                                    },
                                                                                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.4)",
                                                                                                },
                                                                                            },
                                                                                        }}
                                                                                    >

                                                                                        {eventsList.map((item, index) => (
                                                                                            <MenuItem key={index} value={item._id} disableRipple>
                                                                                                <Box display="flex" alignItems="center">
                                                                                                    <Box
                                                                                                        component="span"
                                                                                                        sx={{
                                                                                                            width: 8,
                                                                                                            height: 8,
                                                                                                            borderRadius: "50%",
                                                                                                            marginRight: 1,
                                                                                                            backgroundColor:
                                                                                                                item.event_status === 2
                                                                                                                    ? "green"
                                                                                                                    : item.event_status === 1
                                                                                                                        ? "orange"
                                                                                                                        : "red",
                                                                                                        }}
                                                                                                    />
                                                                                                    {truncateText(item.name, 24)}
                                                                                                </Box>
                                                                                            </MenuItem>
                                                                                        ))}

                                                                                    </Select>
                                                                                </FormControl>
                                                                            }
                                                                        />

                                                                        <CustomInput
                                                                            label="Button Text"
                                                                            input={
                                                                                <TextField size='small' fullWidth placeholder='Enter text.'
                                                                                    inputProps={{ maxLength: 20 }}
                                                                                    value={ite?.text}
                                                                                    disabled
                                                                                    onChange={(e) => handleChangeValue('visiteButton.text', { index, text: e.target.value })}
                                                                                    InputProps={{
                                                                                        endAdornment: (
                                                                                            <InputAdornment position="end" >
                                                                                                <Typography sx={{ fontSize: "14px" }}>
                                                                                                    {ite?.text?.length}/20
                                                                                                </Typography>
                                                                                            </InputAdornment>
                                                                                        ),
                                                                                    }}
                                                                                />
                                                                            }
                                                                        />
                                                                    </Stack>
                                                                    <CustomInput
                                                                        label="Select Package"
                                                                        input={
                                                                            <Select fullWidth select placeholder='Select a pkg to generate QR for'
                                                                                value={ite.package || "1"}
                                                                                disabled={isRead}
                                                                                onChange={(e) => {
                                                                                    const { value } = e.target
                                                                                    const data = packages.find((it) => it?.package_map_id == value)
                                                                                    handleChangeValue('visiteButton.package', { index, package: value })
                                                                                    setSelectPackage(data)
                                                                                }}
                                                                                sx={{ color: selectPackage?.package_map_id ? "white" : "grey" }}
                                                                            >
                                                                                <MenuItem value="1" disabled>
                                                                                    Select a pkg to generate QR for
                                                                                </MenuItem>
                                                                                {

                                                                                    packages?.map((it) => {
                                                                                        return (
                                                                                            <MenuItem value={it?.package_map_id}>
                                                                                                {it?.name}
                                                                                            </MenuItem>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        }
                                                                    />
                                                                </Paper>}
                                                            </Paper>
                                                        )
                                                    })
                                                }
                                            </Stack>


                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid xs={12} md={4} sx={{ position: "sticky", top: 0 }}>
                        <Paper sx={{ margin: "10px", position: "sticky", top: 70 }}>
                            <Box sx={{ background: "white", color: "black", padding: "10px" }}>
                                <Typography variant="h6">Template preview</Typography>
                            </Box>
                            <Box sx={{ background: "#ffffff38", padding: "20px 15px", display: "flex", flexDirection: "column" }}>
                                <Box sx={{
                                    position: "relative",
                                    background: "white",
                                    color: "black",
                                    borderRadius: "6px",
                                    borderTopLeftRadius: "0",
                                    maxWidth: "250px",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                                    "::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        left: "-8px",
                                        width: 0,
                                        height: 0,
                                        borderTop: "10px solid white",
                                        borderLeft: "10px solid transparent",
                                    },
                                }}>
                                    <Box sx={{ padding: "10px 15px", }}>
                                        {(state?.header?.text && state?.header?.format === 'TEXT') && <Typography variant='h6' sx={{ fontSize: "14px !important", wordBreak: "break-all" }}>
                                            {generateOutput(state?.header?.text, extractPlaceholders(state?.header?.text, state), state?.header?.example?.header_text)}
                                        </Typography>}
                                        {(state?.selectedImage && state?.header?.format === 'IMAGE') && (
                                            <div style={{ width: "100%", height: "auto", maxHeight: "200px", overflow: "hidden", marginBottom: "10px" }}>
                                                <img src={state?.selectedImage} alt="Selected" width="100%" height="100%" />
                                            </div>
                                        )}
                                        {(state?.selectedVideo && state?.header?.format === 'VIDEO') && (
                                            <div style={{ width: "100%", height: "auto", maxHeight: "200px", overflow: "hidden", marginBottom: "10px" }}>
                                                <video
                                                    controls src={state?.selectedVideo} alt="Selected" width="100%" height="100%" />
                                            </div>
                                        )}
                                        <Typography sx={{
                                            fontSize: "12px !important",
                                            whiteSpace: "pre-wrap",
                                        }} dangerouslySetInnerHTML={{ __html: generateOutput2(state?.body?.text, state?.bodyplaceholder) }} />
                                        {state?.footerText && <Typography sx={{ fontSize: "12px !important", color: "grey", wordBreak: "break-all" }} >
                                            {state?.footerText}
                                        </Typography>}


                                        <Typography sx={{ fontSize: "10px", color: "gray", textAlign: "right", marginTop: "5px" }}>
                                            {dayjs().format('hh:mm')}
                                        </Typography>
                                    </Box>
                                    {state?.visiteButton?.filter((it) => it?.status).length > 0 && state?.visiteButton?.filter((it) => it?.status).map((it) => {
                                        return (
                                            <Typography sx={{ fontSize: "12px !important", color: "grey", wordBreak: "break-all", padding: "8px 0px", background: "white", maxWidth: "250px", borderTop: "1px solid lightGrey", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }} color="primary" key={it?.text} >
                                                {
                                                    it?.label == 'Other' ?
                                                        <LaunchIcon /> : it?.label == 'Copy offer code' ?
                                                            <ContentCopyIcon /> : it?.label == 'RSVP' ? <CallIcon /> :
                                                                it?.label == 'Chat with us'
                                                                    ? <ReplyIcon /> : it?.label == 'Join As Guest' ? <ReplyIcon /> : ""
                                                }  {it?.text}
                                            </Typography>
                                        )
                                    })}
                                </Box>

                            </Box>


                        </Paper>

                    </Grid>


                </Grid>
                <Stack direction="row" gap="10px" marginTop="20px">
                    <LoadingButton loading={loadingBtn} disabled={loadingBtn || isRead} variant="contained" onClick={handleSubmit}>Submit</LoadingButton>
                    <Button variant="outlined" onClick={() => navigate("/dashboard/campaign/template", { state: location?.state?.isreadOnly })} >Cancel</Button>
                </Stack>
            </Container >
        </div >
    )
}
